import PageHeading from 'components/shared/PageHeading'
import React from 'react'
import { Button, ButtonGroup, Card, Col, Container, Row } from 'react-bootstrap'
import logo from 'assets/logoIcon.png'
import image from 'assets/connect.png'
import icon1 from 'assets/connect/cubes 1.png'
import icon2 from 'assets/connect/high.png'
import icon3 from 'assets/connect/projects.png'
import ContactForm from 'components/ConnectForm'
import { Arrow } from 'assets/SVG'
import { Link } from 'react-scroll'

const connectData = [
    { icon: icon1, heading: "Digital Space Activation", text: "Transforming your spaces with cutting-edge technology." },
    { icon: icon2, heading: "High-End Digital Art", text: "Creating impactful and engaging art installations." },
    { icon: icon3, heading: "Custom Projects", text: "Have something unique in mind? We’re here to help bring your vision to life." }
]

const Connect = () => {
    return (
        <Container className='py-5' >
            <div className="mb-3 text-center">
                <PageHeading image={logo} text={"Connect"} />
            </div>


            <Row>


                <Col md={6} xs={12}>
                <h2 className="fw-bold mb-0">
                        Connect with Living Wall:
                    </h2>
                    <h2>
                        <strong>Your Partner in </strong>
                        <i>Digital Innovation</i>
                    </h2>
                    <p className="my-4">
                        Ready to transform your brand and community? Connect with Living Wall to discuss digital placemaking, LED walls, and custom projects tailored to your needs.
                    </p>
                    <Col xl={4} lg={5} md={12}>
                        <ButtonGroup className="d-flex btn-group mb-4">
                            <Link
                                to="Connect"
                                smooth={true}
                                duration={500}
                            >
                                <Button className="btn-custom px-4">
                                    <small>Learn More</small>
                                </Button>
                            </Link>
                            <span className="arrow">
                                <Arrow />
                            </span>
                        </ButtonGroup>
                    </Col>

                </Col>
                <Col md={6} xs={12}>
                                <h5 className="fw-bold">
                        Where Innovation Meets Community
                    </h5>
                    <p>At Living Wall, we're not just a service provider. We're your trusted partner in digital innovation. No matter if you're interested in digital space activation, high-end digital art, or a custom project that is tailored to your needs, we're here to listen, adapt, and exceed your expectations.</p>
                    <h6 className='py-4'>
                        <strong>
                            <i>Ready to take the next step? Let's connect!</i>
                        </strong>
                    </h6>
                </Col>
            </Row>
            <Row >
                <Col md={6}>
               
                    <Card className="shadow-sm rounded-4 border-0 p-4 pb-2 mt-3">
                        <Card.Img variant="top" src={image} className="img-fluid" alt="Project Image" />
                        <Card.Body className="d-flex flex-column">
                            <Card.Title className="mb-3">
                                <strong>Got an Idea/Project in Mind?</strong>
                                <i> We're all ears.</i>
                            </Card.Title>
                            <p className='small py-2'>Would you like to connect with us to discuss:</p>
                            <div>
                                {connectData.map((c, i) => (
                                    <div key={i} className="d-flex gap-2 mb-3">
                                        <div style={{ height: "30px", width: "30px" }}>
                                            <img src={c.icon} alt="Connect" className='img-fluid' />
                                        </div>
                                        <div>
                                            <h6>

                                                <strong>
                                                    {c.heading}

                                                </strong>
                                            </h6>
                                            <p className="small">{c.text}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </Card.Body>
                    </Card>
                </Col>

                <Col className='ps-lg-5  mt-md-0 mt-4' md={6}>


                    <h3>
                        <strong>Ready to Connect?</strong>
                    </h3>
                    <p className="mt-4 mb-0">
                        If you're as excited as we are about the endless possibilities, don't hesitate. Reach out today and <strong className='px-1'>let's build something extraordinary together.</strong>
                    </p>

                    <ContactForm />
                </Col>
            </Row>
        </Container>
    )
}

export default Connect
